import { isNonEmptyString } from '@nora-monorepo/shared';
import { useGenericUserStore } from '@nora-monorepo/ui-shared';

import { useOperationStore } from '#nora-ui/stores/operation-store';

/**
 * Checks whether the current user, stored in the userStore, has the specified permission. Optionally, you can make this call specific to an operation.
 * @param permission
 * @param operationId
 */
export function operationCan(permission: string, operationId?: string | null): boolean {
  const userStore = useGenericUserStore();

  if (!userStore.user) {
    return false;
  }

  if (!isNonEmptyString(operationId)) {
    if (userStore.user.permissions?.includes(permission) !== true) {
      return false;
    }
  }
  else {
    if (userStore.user.permissions?.includes(permission) === true) {
      return true;
    }
    const operationStore = useOperationStore();
    const permissions = operationStore.getOperationPermissions(operationId);

    if (permissions.length === 0) {
      return false;
    }

    if (!permissions.includes(permission)) {
      return false;
    }
  }

  return true;
}
